export const formatMoneyInteger = (
  number: number,
  fractionDigits: number = 0,
  divisor: number = 1
) => {
  if (divisor > 1) {
    number = number / divisor
  }

  return (number || 0)
    .toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    })
    .replace(/\$/g, '')
}
